import { Injectable } from '@angular/core';
import {AppConfigService} from './app-config.service';
import {HttpClientService} from './http-client.service';

@Injectable()
export class SkySwitchSSOService {

  private apiUrl = AppConfigService.settings.apiUrl + 'auth/';  // URL to web api

  constructor(private http: HttpClientService) { }

  ssoLogin(loginName, authToken, refreshToken): Promise<any[]> {
    const body = new FormData();
    body.append('login_name', loginName);
    body.append('auth_token', authToken);
    body.append('refresh_token', refreshToken);
    return this.http.post(this.apiUrl + 'skyswitch/sso', body)
      .toPromise()
      .then(response => response.json() as any[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/skyswitch-sso.service.ts